import ListsPage from "@Alternatives/AlternativesViews/Pages/ListsPage.vue";

export const routes = [
    { path: "/portfolio/lists-manager/:workspaceId/:projectId", component: ListsPage },
    { path: "/decision/lists-manager/:workspaceId/:projectId", component: ListsPage },
]
